import React from 'react';
import PropTypes from 'prop-types';

const GetLateralPercentage = (target, mark_count) => (
  (target.characteristic.score / 100) * (mark_count * 9 - 5)
);

const TargetRangeMarker = ({ index, range, length }) => {
  const offset = index * 9;
  const percent = (index / length) * 100;

  let heightOffset = 55;
  let topOffset = (index % 5 === 0 ? 0 : 15) + heightOffset;

  const inRange = percent > range.start && percent < range.end;

  if (inRange) {
    // heightOffset+=5;
    topOffset-=15;
  }

  return (
    <path className={[
      'personal-target-grouping-targets-range-item',
      inRange ? 'personal-target-grouping-targets-range-item-range' : '',
      percent <= 25 || percent >= 75 ? 'personal-target-grouping-targets-item-end' : ''
    ].filter(c=>c).join(' ')} d={[
      `M${offset},${topOffset+2}`,
      `C${offset},${topOffset+1}`,
      `${offset+0},${topOffset}`,
      `${offset+2},${topOffset}`,
      `C${offset+3},${topOffset}`,
      `${offset+4},${topOffset}`,
      `${offset+4},${topOffset+2}`,
      `L${offset+4},${heightOffset + 30}`,
      `L${offset+0},${heightOffset + 30}`,
      `L${offset+0},${topOffset+2}`,
      `Z`
    ].join(' ')}></path>
  );
};

TargetRangeMarker.propTypes = {
  index: PropTypes.number,
  range: PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number
  }),
  length: PropTypes.number
};

const TargetRange = ({ target, mark_count=101 }) => (
  <svg viewBox={`0 0 ${mark_count*9-5} 85`} x="0px" y="0px" className="personal-target-grouping-targets-range">

    <g className="personal-target-grouping-targets-range-blip" transform={`translate(${GetLateralPercentage(target, mark_count) - 13})`}>
      <path d="M13,0 C5.75714286,0 0,5.735 0,12.95 C0,22.57 13,37 13,37 C13,37 26,22.57 26,12.95 C26,5.735 20.2428571,0 13,0 L13,0 Z" id="Shape"></path>
    </g>
    <g>
      {
        [...Array(mark_count-1)].map((v,i,a)=><TargetRangeMarker range={target.percentile_range} length={a.length} key={i} index={i} />)
      }
      <TargetRangeMarker range={target.percentile_range} length={101} index={100} />
    </g>
  </svg>
);

TargetRange.propTypes = {
  target: PropTypes.object,
  mark_count: PropTypes.number
};

export default TargetRange
